const STORAGE_KEY = "@goinbag:app_state";

export const saveToGlobalState = (newData) => {
  const rawState = localStorage.getItem(STORAGE_KEY);
  const currentState = rawState ? JSON.parse(rawState) : {};

  const updatedState = { ...currentState, ...newData };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedState));
};

export const getStoredData = () => {
  const rawState = localStorage.getItem(STORAGE_KEY);
  return rawState ? JSON.parse(rawState) : {};
};

export const removeSpecificData = (keyToRemove) => {
  const rawState = localStorage.getItem(STORAGE_KEY);
  if (!rawState) return;

  const currentState = JSON.parse(rawState);
  delete currentState[keyToRemove];

  localStorage.setItem(STORAGE_KEY, JSON.stringify(currentState));
};

export const clearAppState = () => {
  localStorage.removeItem(STORAGE_KEY);
};
